import { render, staticRenderFns } from "./AddCourseExam.vue?vue&type=template&id=79ff5255&scoped=true&"
import script from "./AddCourseExam.vue?vue&type=script&lang=js&"
export * from "./AddCourseExam.vue?vue&type=script&lang=js&"
import style0 from "./AddCourseExam.vue?vue&type=style&index=0&id=79ff5255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ff5255",
  null
  
)

export default component.exports